export class SettingsStateConfig {
    public url: string;
    public auth: boolean = false;
    public templateUrl?: string;
    public template?: string;
}